import { useEffect, useLayoutEffect as useRealLayoutEffect } from 'react';

/**
 * Needed to supress the SSR warning when running use layout effect on the server.
 */
export var useLayoutEffect = typeof window === 'undefined' ? useEffect : useRealLayoutEffect;